import { http } from "../services";
export const thisweekResult = (queryData) => {
  return http.get("/leaderboard", {
    params: queryData,
  });
};

/** Previous week leaderboard; backend may read `previousWeek` (adjust if your API differs). */
export const lastweekResult = (queryData) => {
  return http.get("/leaderboard", {
    params: { ...queryData, previousWeek: true },
  });
};

export const searchUsers = (searchQuery, limit = 10) => {
  return http.get(`/users/search/${searchQuery}/${limit}`, {
  });
};